import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import { Box, Chip, Tooltip, Typography } from '@mui/material';
import { STATUS_CLASS_MAP, STATUS_COLOR_MAP } from '../../../utils/constants';
import { secondsToTime } from '../../../utils/util';

const AgentStatusCard = ({
    agent,
    action
}: any) => {

    const hasMetric = (key: 'TotalCalls' | 'AnsweredCalls' | 'AbandonedCalls') => {
        try {
            return agent && Object.prototype.hasOwnProperty.call(agent, key) && agent[key] !== null && agent[key] !== undefined && agent[key] !== '';
        } catch (error) {
            return false;
        }
    }
    const shouldShowMetrics = hasMetric('TotalCalls') || hasMetric('AnsweredCalls') || hasMetric('AbandonedCalls');
    const getMetricValue = (key: 'TotalCalls' | 'AnsweredCalls' | 'AbandonedCalls') => {
        try {
            if (!hasMetric(key)) {
                return null;
            }
            return agent[key];
        } catch (error) {
            return null;
        }
    };

    return (
        <Box
            sx={{
                width: 160,
                height: 160,
                borderRadius: '50%',
                border: 3,
                borderColor: STATUS_COLOR_MAP[agent.AgentState]?.color || 'grey.300',
                bgcolor: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                p: 1.5,
                transition: 'box-shadow 0.3s',
                '&:hover': {
                    boxShadow: 3,
                    cursor: 'pointer',
                    border: 4,
                    borderColor: STATUS_COLOR_MAP[agent.AgentState]?.color || 'grey.300',
                }

            }}
            onClick={(event) => action(event, agent)}

        >
            {/* Status Chip */}
            <Chip
                label={agent.AgentState}
                size="small"
                {...((((typeof agent?.HoldDuration === 'object' ? agent?.HoldDuration?.value : agent?.HoldDuration) > 0) && agent?.AgentState === 'BUSY') && {
                    deleteIcon: (
                        <PauseCircleIcon
                            sx={{
                                color: 'red !important',
                                position: 'absolute',
                                top: '-8px',
                                right: '-18px',
                                fontSize: '18px'
                            }}
                        />
                    ),
                    onDelete: () => { }
                })}
                className={STATUS_CLASS_MAP[agent.AgentState]}
                sx={{
                    height: 24,
                    maxWidth: '105px',
                    fontSize: '13px',
                    fontWeight: 600,
                    bgcolor: STATUS_COLOR_MAP[agent.AgentState]?.bg || 'grey.400',
                    color: STATUS_COLOR_MAP[agent.AgentState]?.color || 'white',
                    mb: 0.75,
                    '& .MuiChip-label': {
                        px: 1.25,
                        py: 0
                    }
                }}
            />

            {/* Timer */}
            <Typography
                sx={{
                    fontSize: '22px',
                    fontWeight: 600,
                    color: 'text.primary',
                }}
            >
                {secondsToTime(agent?.Since)}
            </Typography>

            {shouldShowMetrics && (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        flexWrap: 'wrap',
                        maxWidth: '138px'
                    }}
                >
                    {getMetricValue('TotalCalls') !== null && (
                        <Typography sx={{ fontSize: '11px', fontWeight: 600, color: 'text.secondary' }}>
                            {`T: ${getMetricValue('TotalCalls')}`}
                        </Typography>
                    )}
                    {getMetricValue('AnsweredCalls') !== null && (
                        <Typography sx={{ fontSize: '11px', fontWeight: 600, color: 'success.main' }}>
                            {`AN: ${getMetricValue('AnsweredCalls')}`}
                        </Typography>
                    )}
                    {getMetricValue('AbandonedCalls') !== null && (
                        <Typography sx={{ fontSize: '11px', fontWeight: 600, color: 'warning.main' }}>
                            {`UN: ${getMetricValue('AbandonedCalls')}`}
                        </Typography>
                    )}
                </Box>
            )}

            {/* Skills/App Name - Fixed center alignment */}
            <Typography
                component="div"
                sx={{
                    fontSize: '11px',
                    color: 'text.disabled',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    maxWidth: '138px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    mb: 0.75,
                    lineHeight: 1.2,
                    '& .badge': {
                        fontSize: '9px',
                        marginLeft: '4px',
                        padding: '0px 5px',
                        lineHeight: 1.6,
                        flexShrink: 0
                    }
                }}
            >
                {agent?.SkillsFormatted || 'N/A'}
            </Typography>

            {/* Agent Name */}
            <Tooltip title={agent?.AgentName || 'Unknown'}>
                <Typography
                    sx={{
                        fontSize: '15px',
                        fontWeight: 500,
                        color: 'primary.main',
                        textAlign: 'center',
                        maxWidth: '98px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        lineHeight: 1.2
                    }}
                >
                    {agent?.AgentName || 'Unknown'}
                </Typography>
            </Tooltip>
        </Box>
    );
};

export default AgentStatusCard;
